import React, { SFC } from 'react';
import classNames from 'classnames';

import styles from './user-signup.module.styl';
import { getTranslator } from '../../../helpers/i18n';
import { IllustrationMailMotion } from '@grpn/mx-components';

const translate = getTranslator('_success._userSignup');

const Return: SFC = () => (
  <div className={classNames('mx-main', styles.container)}>
    <h2>{translate('title')}</h2>
    <div className={styles.topIconContainer}>
      <IllustrationMailMotion height={64} widht={64} />
    </div>
    <br />
    <p>{translate('subtitle')}</p>
  </div>
);

export default Return;
